import Backbone from 'backbone'
import template from './config-timeline-range.hbs'
import CalendarOrDateRangeSelector from 'scoreboard/components/calendar-or-date-range-selector'
import Dataset from 'scoreboard/datasets/model/dataset'
const { ALL_TIME } = Dataset
import _ from 'lodash'

const ConfigTimelineRange = Backbone.View.extend({
	events: {
		'click .save': 'save'
	},

	render() {
		this.$el.append(template())

		let props = this.model.properties.toJSON()

		let range = {}
		let dates = {}
		let chooseBy = _.isNil(props.startDate) ? 'calendar-period' : 'day'

		if (chooseBy === 'calendar-period') {
			let calendarId = props.calendarId
			if (calendarId == ALL_TIME) {
				range.calendarId = ALL_TIME
			} else {
				range.calendarId = calendarId
				if (_.isNil(props.startPeriodId)) {
					range.relative = true
					range.first = props.startPeriodDelta
					range.last = props.endPeriodDelta
				} else {
					range.relative = false
					range.first = props.startPeriodId
					range.last = props.endPeriodId
				}
			}
		} else {
			dates = _.pick(props, 'startDate', 'endDate')
		}

		this.rangeSelector = new CalendarOrDateRangeSelector({
			chooseBy,
			dates,
			range,
			canChangeCalendar: true,
			allowAllTime: true
		})

		this.$('.panel-content').append(this.rangeSelector.el)
		this.rangeSelector.render()

		return this
	},

	save() {
		let val = this.rangeSelector.val()

		let update = {
			startDate: null,
			endDate: null,
			calendarId: null,
			startPeriodId: null,
			endPeriodId: null,
			startPeriodDelta: null,
			endPeriodDelta: null
		}

		if (val.chooseBy === 'calendar-period') {
			let range = val.range
			if (range.calendarId == ALL_TIME) {
				update.calendarId = ALL_TIME
			} else {
				update.calendarId = range.calendarId
				if (range.relative) {
					update.startPeriodDelta = range.first
					update.endPeriodDelta = range.last
				} else {
					update.startPeriodId = range.first
					update.endPeriodId = range.last
				}
			}
		} else {
			_.extend(update, val.dates)
		}


		this.model.properties.set(update)
		this.trigger('done')
	},

	remove() {
		Backbone.View.prototype.remove.apply(this, arguments)
		this.rangeSelector && this.rangeSelector.remove()
	}
})

export default ConfigTimelineRange

ConfigTimelineRange.__filename__ = 'dashboards/widgets/initiative-timeline/config-timeline-range.js'
